export function ucfirst(str: string): string {
    if (!str) return str; // Return empty string if input is empty
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function newportRounding(n: number): number {
    return n > Math.floor(n) + 0.6 ? Math.ceil(n) : Math.floor(n);
}
